var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fa  fa-circle-o-notch  fa-spin fa-2x position-absolute fa-fw",class:'text-' + _vm.color,staticStyle:{"top":"50%","left":"45%"}})}
var staticRenderFns = []

export { render, staticRenderFns }